export const formatarMoeda = (valor) => {
  if (!valor && valor !== 0) return '';
  
  return Number(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}; 